import React from 'react';
import { BeltPromotion } from '../../store/slices/beltProgressionSlice';
import ShareBeltPromotion from './ShareBeltPromotion';

interface ShareBeltPromotionModalProps {
  isOpen: boolean;
  onClose: () => void;
  promotion: BeltPromotion | null;
  onSuccess?: () => void;
}

const ShareBeltPromotionModal: React.FC<ShareBeltPromotionModalProps> = ({
  isOpen,
  onClose,
  promotion,
  onSuccess
}) => {
  if (!isOpen || !promotion) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div 
        className="animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        <ShareBeltPromotion 
          promotion={promotion}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  );
};

export default ShareBeltPromotionModal;